import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../component/common/Navbar";
import Footer from "../component/common/Footer";
import styles from "./Error.module.css";

const Error = () => {
  return (
    <div>
      <Navbar />
      <div className={styles.errorContainer}>
        <div className="section">
          <div className={styles.errorSection}>
            <h1>404</h1>
            <h3> Sorry, the page you tried cannot be found</h3>
            <Link to="/" className={`primary-btn ${styles.backHomeBtn}`}>
              back home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Error;
